import { useState } from 'react';
import { SelectOption } from '@trukt/ui/SelectOption';
import { useDebounce } from '@trukt/react-hooks/useDebounce';
import { useOptionWithBranchResults } from '@trukt/react-hooks/useOptionWithBranchResults';
import { Option } from '@trukt/portal-utils/Option';
import { SearchBranchInputProps } from './SearchBranchInput.types';
import { useBranchOptionsQuery } from './hooks';

export type BranchFilterData = {
  id: string;
  label: string;
};

export const SearchBranchInput = ({ addOption }: SearchBranchInputProps) => {
  const [search, setSearch] = useState<string>('');
  const handleInputChange = useDebounce((inputValue: string) => setSearch(inputValue));

  const branchOptionsQuery = useBranchOptionsQuery(search);
  const branchOptions = useOptionWithBranchResults(branchOptionsQuery.data?.data);

  const handleChange = (selectedOption: Option<string>) =>
    addOption(
      buildBranchOption({
        id: selectedOption.value,
        label: selectedOption.label,
      }),
    );

  return (
    <div className="w-[12vw]">
      <SelectOption
        variant="search"
        placeholder="Branch"
        selectedValueId=""
        aria-label="Search for a branch"
        isLoading={branchOptionsQuery.isFetching}
        options={branchOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
      />
    </div>
  );
};

export function buildBranchOption(data: BranchFilterData) {
  return {
    id: data.id,
    label: data.label,
    data,
    stateModifiers: {
      isActive: true,
    },
  };
}
